export default "__VITE_ASSET__d425565f__"